
<!--start section header-->
<header class="head">
    



 <div class="content text-white d-flex justify-content-center align-items-center text-center position-relative">
    <div>
       <img src="assets/images/logo.png"  class="mt-5 img-widt">
       <h1 class="mt-3 ">DELICIOUS FOOD</h1>
       <h2 class="mt-3">Tomato is a delitious restaurant website template</h2>
       <a class="pointer">
           <img (click) = "down()" src="assets/images/arrow-down.png"  alt="arrow-down">
        </a>
       
    </div>
 </div>
   
   
  



</header>
<!--end section header-->

<!--start section about-->
<section id="about" class="container pt-5 mb-5 about">
   <div class=" text-center"> 
      <h1>THE RESTAURANT</h1>
      <p class="text-muted">A little about us and a breif history of how we started.</p>
      <div class="mini m-auto"></div>
   </div> 
   <div class="row py-5">
       <div class="col-lg-4 col-md-12 position-relative about-img">
       
        <div class="row">
            <div class="col-md-12 col-sm-12 about-img1">
                <img src="assets/images/thumb1.png" class="img-fluid">
            </div>
            <div class="col-lg-6 col-md-6 mt-2 about-img2 ">
                <img src="assets/images/thumb3.png" class="img-fluid">
            </div>
            <div class="col-md-6 col-md-6 mt-2 about-img2">
                <img src="assets/images/thumb2.png" class="img-fluid">
            </div>
        </div>
           
       </div>
       <div class="col-lg-8 col-md-12 about-cont position-relative">
           <h3 class="">Cras ut viverra eros. Phasellus sollicitudin sapien id luctus tempor. 
               Sed hend rerit inter dum sagittis. Donec nunc lacus, dapibus nec interdum eget,
                ultrices eget justo. Nam purus lacus, efficitur eget laoreet sed, finibus nec neque.
                 Cras eget enim in diam dapibus sagittis. In massa est, dignissim in 
               libero ac, fringilla ornare mi. Etiam interdum ligula purus.</h3>
           <h3 class="pt-3">Ultrices eget justo. Nam purus lacus, efficitur eget laoreet sed, 
                   finibus nec neque. Cras eget enim in diam dapibus sagittis.
                    In massa est, dignissim in libero ac, fringilla ornare.</h3>
            <img src="assets/images/signature.png" class="img-fluid" alt="">        

       </div>






   </div> 


</section>
<!--end section about-->

<!--start section carsouel-->
<section class="pt-4  mb-5 pb-5 text-white carsel">
  <div class="text-center">
    <h1>TODAY'S SPECIALS</h1>
      <p class="text-white bld">A little about us and a breif history of how we started.</p>
      <div class="mini m-auto mb-3"></div>
  </div>
  <div id="carouselExampleControls" class="carousel slide mt-5 pb-4" data-ride="carousel">
    <div class="carousel-inner">
      <div class="carousel-item active">
        <img src="assets/images/steak3.jpg" class="d-block w-50 m-auto img-fluid" alt="...">
      </div>
      <div class="carousel-item">
        <img src="assets/images/steak8.jpg" class="d-block w-50 m-auto img-fluid" alt="...">
      </div>
      <div class="carousel-item">
        <img src="assets/images/steak6.jpg" class="d-block w-50 m-auto img-fluid" alt="...">
      </div>
    </div>
    <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
      <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
      <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span>
    </a>
  </div>
  
  
</section>
<!--end section carsouel-->

<!--start section reserv-->
<section class="container py-5 reserv">
  <div class=" text-center"> 
    <h1>RESERVATIONS</h1>
    <p class="text-muted">Book a table online. Leads will reach in your email.</p>
    <div class="mini m-auto mb-5"></div>
 </div> 
 <div class="row mt-3">

    <div class="col-md-4 mb-3">
      <div class="form-group">
        <label>Data</label>
        <input  name="udata" class="form-control input-cont border-0" placeholder="Pick a data" >
       
      </div>

    </div>
    <div class="col-md-4 mb-3">
      <div class="form-group">
        <label>Your Name</label>
        <input type="text" name="uname" class="form-control input-cont border-0" placeholder="Full Name">
        
      </div>

    </div>
    <div class="col-md-4 mb-3">
      <div class="form-group">
        <label>Time</label>
        <input  name="utime" class="form-control input-cont border-0" placeholder="Pick a Time">
      </div>

    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Email Address</label>
        <input type="email" name="uemail" class="form-control input-cont border-0" placeholder="Your Email ID">
      </div>

    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>Guests</label>
        <input type="text" name="uguests" class="form-control input-cont border-0" placeholder="How Many You">
      </div>

    </div>
    <div class="col-md-4">
      <div class="form-group">
        <label>phone Number</label>
        <input type="number" name="unumber" class="form-control input-cont border-0" placeholder="Enter your phone Number">
      </div>

    </div>
    
    
  
 </div>

      <div class="m-auto pt-4 pb-4 text-center">
         <button type="submit" class="btn btn-reserv p-3">MAKE RESERVATIONS</button>
      </div>
      <div class="reserv-footer m-auto text-center p-4">
         <p class="text-muted">You can also call: <span >+1 224 6787 004</span> to make a reservation.</p>
      </div>


</section>
<!--end section reserv-->

<!--start section features-->
<section class="py-5 features">
  <div class="container">
    <div class=" text-center mb-4"> 
      <h1 class="text-white">OUR FEATURES</h1>
      <p class="text-white ">Little things make us best in town</p>
      <div class="mini m-auto "></div>
   </div> 

   <div class="row">

    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12  ">

      <div class="features-cont">
        <img src="assets/images/thumb5.png" class="img-fluid" alt="food">
        <div class="feature-caption p-2 bg-white">
            <h3 class="pt-3 pl-3">SERVING WITH LOVE</h3>
            <div class="mini-width ml-3"></div>
            <p class="pt-3 text-muted pl-3">Aenean suscipit vehicula purus quis iaculis. Aliquam nec leo nisi. 
               Nam urna arcu,maximus eget ex nec, consequat pellentesque enim.
               Aliquam tempor fringilla odio, vel ullamcorper<br> turpis varius eu.
            </p>
        </div>

      </div>

    </div>
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">

      <div class="features-cont">
        <img src="assets/images/thumb6.png" class="img-fluid" alt="food">
        <div class="feature-caption p-2 bg-white">
            <h3 class="pt-3 pl-3">SERVING WITH LOVE</h3>
            <div class="mini-width ml-3 "></div>
            <p class="pt-3 text-muted pl-3">Aenean suscipit vehicula purus quis iaculis. Aliquam nec leo nisi. 
               Nam urna arcu,maximus eget ex nec, consequat pellentesque enim.
               Aliquam tempor fringilla odio, vel ullamcorper<br> turpis varius eu.
            </p>
        </div>

      </div>

    </div>
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12">

      <div class="features-cont">
        <img src="assets/images/thumb7.png" class="img-fluid" alt="food">
        <div class="feature-caption p-2 bg-white">
            <h3 class="pt-3 pl-3">SERVING WITH LOVE</h3>
            <div class="mini-width ml-3"></div>
            <p class="pt-3 text-muted pl-3">Aenean suscipit vehicula purus quis iaculis. Aliquam nec leo nisi. 
               Nam urna arcu,maximus eget ex nec, consequat pellentesque enim.
               Aliquam tempor fringilla odio, vel ullamcorper<br> turpis varius eu.
            </p>
        </div>

      </div>

    </div>




   </div>
  </div>
  
</section>
<!--end section features-->

<!--start section menu-->
<section class="py-5 container menu">
  <div class="text-center pb-5">
    <h1>OUR MENU</h1>
      <p class="text-muted bld">These fine folks trusted the award winning restaurant.</p>
      <div class="mini m-auto"></div>
  </div>
  <div class="row">

      <div class="col-lg-6 col-md-12  ">

        <div class="d-flex menu-caption">
          <h4>ENGLISH ASPARAGUS</h4>
          <p class="px-2 text-muted menu-dot">...........................................</p>
          <span class="pl-2">$14.95</span>
        </div>
        <p class="text-muted menu-p">pellentesque enim. Aliquam tempor</p>
           
      </div>
      <div class="col-lg-6 col-md-12">

        <div class="d-flex menu-caption">
          <h4>ENGLISH ASPARAGUS</h4>
          <p class="px-2 text-muted">...........................................</p>
          <span class="pl-2">$14.95</span>
        </div>
        <p class="text-muted menu-p">pellentesque enim. Aliquam tempor</p>
           
      </div>
      <div class="col-lg-6 col-md-12">

        <div class="d-flex menu-caption">
          <h4>ENGLISH ASPARAGUS</h4>
          <p class="px-2 text-muted">...........................................</p>
          <span class="pl-2">$14.95</span>
        </div>
        <p class="text-muted menu-p">pellentesque enim. Aliquam tempor</p>
           
      </div>
      <div class="col-lg-6 col-md-12">

        <div class="d-flex menu-caption">
          <h4>ENGLISH ASPARAGUS</h4>
          <p class="px-2 text-muted">...........................................</p>
          <span class="pl-2">$14.95</span>
        </div>
        <p class="text-muted menu-p">pellentesque enim. Aliquam tempor</p>
           
      </div>
      <div class="col-lg-6 col-md-12">

        <div class="d-flex menu-caption">
          <h4>ENGLISH ASPARAGUS</h4>
          <p class="px-2 text-muted">...........................................</p>
          <span class="pl-2">$14.95</span>
        </div>
        <p class="text-muted menu-p">pellentesque enim. Aliquam tempor</p>
           
      </div>
      <div class="col-lg-6 col-md-12">

        <div class="d-flex menu-caption">
          <h4>ENGLISH ASPARAGUS</h4>
          <p class="px-2 text-muted">...........................................</p>
          <span class="pl-2">$14.95</span>
        </div>
        <p class="text-muted menu-p">pellentesque enim. Aliquam tempor</p>
           
      </div>
      <div class="col-lg-6 col-md-12">

        <div class="d-flex menu-caption">
          <h4>ENGLISH ASPARAGUS</h4>
          <p class="px-2 text-muted">...........................................</p>
          <span class="pl-2">$14.95</span>
        </div>
        <p class="text-muted menu-p">pellentesque enim. Aliquam tempor</p>
           
      </div>
      <div class="col-lg-6 col-md-12">

        <div class="d-flex menu-caption">
          <h4>ENGLISH ASPARAGUS</h4>
          <p class="px-2 text-muted">...........................................</p>
          <span class="pl-2">$14.95</span>
        </div>
        <p class="text-muted menu-p">pellentesque enim. Aliquam tempor</p>
           
      </div>
      <div class="col-lg-6 col-md-12">

        <div class="d-flex menu-caption">
          <h4>ENGLISH ASPARAGUS</h4>
          <p class="px-2 text-muted">...........................................</p>
          <span class="pl-2">$14.95</span>
        </div>
        <p class="text-muted menu-p">pellentesque enim. Aliquam tempor</p>
           
      </div>
      <div class="col-lg-6 col-md-12">

        <div class="d-flex menu-caption">
          <h4>ENGLISH ASPARAGUS</h4>
          <p class="px-2 text-muted">...........................................</p>
          <span class="pl-2">$14.95</span>
        </div>
        <p class="text-muted menu-p">pellentesque enim. Aliquam tempor</p>
           
      </div>

  </div>

  <div class="m-auto pt-4 pb-4 text-center">
    <button  class="btn btn-reserv p-3">EXPLORE OUR MENU</button>
 </div>
</section>
<!--end section menu-->

<!--start section trusted-->
<section class="py-5 container trusted ">
  <div class="text-center pb-5">
    <h1>TRUSTED BY</h1>
      <p class="text-muted bld">These fine folks trusted the award winning restaurant.</p>
      <div class="mini m-auto"></div>
  </div>

  
      
  <owl-carousel-o [options]="customOptions" class="center">
    
      <ng-template carouselSlide><img src="assets/images/4.png" class="img-fluid w-75 pl-1"></ng-template> 
     
      <ng-template carouselSlide><img src="assets/images/4.png" class="img-fluid w-75"></ng-template>  
      <ng-template carouselSlide><img src="assets/images/4.png" class="img-fluid w-75"></ng-template>  
      <ng-template carouselSlide><img src="assets/images/4.png" class="img-fluid w-75"></ng-template> 
      <ng-template carouselSlide><img src="assets/images/4.png" class="img-fluid w-75"></ng-template> 
  
  </owl-carousel-o>

  
</section>
<!--end section trusted-->

<!-- start section testimonials -->

<section class="mt-5 testimonials">
  <div class="container">
      <div data-slick='{"slidesToShow": 1, "slidesToScroll": 1}' class="testimonial text-white pt-4">
              
                  
          <div class="testimonial-caption text-center">
              <img src="assets/images/quote.png" class="text-white my-5" alt="">
              <p >Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugiat  quam tempore unde voluptates ipsum ut, obcaecati laudantium 
                    reiciendis quia sunt ea dolores ad porro repellat
                 , sint  voluptatibus tempora et delectus! Lorem ipsum 
                 dolor sit amet  consectetur adipisicing elit.
                 Voluptatum id officia repellat amet  expedita enim odio unde quas</p>
                 <p>Anthony Reed, <span>New York</span>
              </p>
          </div>
          <div class="testimonial-caption text-center">
              <img src="assets/images/quote.png" class="text-white my-5" alt="">
              <p >Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugiat quam tempore unde voluptates ipsum ut, obcaecati laudantium 
                    reiciendis quia sunt ea dolores ad porro repellat
                 , sint  voluptatibus tempora et delectus! Lorem ipsum 
                 dolor sit amet  consectetur adipisicing elit.
                 Voluptatum id officia repellat amet expedita enim odio unde quas</p>
                 <p>Gemma Arterton, <span>Bay Area</span>
              </p>
          </div>
          <div class="testimonial-caption text-center">
              <img src="assets/images/quote.png" class="text-white my-5" alt="">
              <p >Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Fugiat  quam tempore unde voluptates ipsum ut, obcaecati laudantium 
                    reiciendis quia sunt ea dolores ad porro repellat
                 , sint voluptatibus tempora et delectus! Lorem ipsum 
                 dolor sit amet  consectetur adipisicing elit.
                 Voluptatum id officia repellat amet expedita enim odio unde quas</p>
                 <p>Zachary Burton, <span>Sanfransisco</span>
              </p>
          </div>
          
      </div>
  </div>
</section>

<!-- end section testimonials -->

<!--start section insta-->
<section class="container py-4 insta">
  <div class="text-center pb-5">
    <h1>INSTAGRAM</h1>
      <p class="text-muted bld">We love posting photos of our coustomers having a good time</p>
      <div class="mini m-auto"></div>
  </div>

 

   <div class="row insta-caption bg">
      <div class="col-md-3 sub-caption">
          <p>SUBSCRIBE</p>
      </div>
      <div class="col-md-8">
       <p class="text-muted p">Get updates about new dishes and upcoming events</p>
   </div>
     
     </div>
     <div class="registers d-flex justify-content-end pb-4">
       <input class="inpt-caption mr-4" type="email" placeholder=" Your Email Address ">
       <button type="submit" class="register"><i class="fas fa-chevron-right fa-1x"></i></button>
     </div>

  
</section>

<!--end section insta-->